module.exports = __webpack_public_path__ + "media/images/fmdd-fav-icon-d9795b01478a63264600aecd19cf6655.png";